import axios from 'axios';
import axiosRetry from 'axios-retry';
import store from './store';
import { navigateLoginUrl } from './utils';

export const authClient = axios.create({
  baseURL: process.env.VUE_APP_AUTHENTICATION_SERVICE_URL,
  withCredentials: true,
});

export const apiClient = axios.create({ withCredentials: true });

apiClient.interceptors.request.use(async (config) => {
  if (store.getters.isAuthExpired) {
    await store.dispatch('refreshAuthWait');
  }

  // access token is included in cookies to be included in file download requests automatically
  // Include only for iframe
  if (store.state.auth.useAuthHeader) {
    const { accessToken } = store.state.auth.jwt;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response.status === 401) {
      if (!error.config.__isRetryRequest) {
        error.config.__isRetryRequest = true;
        await store.dispatch('refreshAuthWait', { force: true });
        return apiClient.request(error.config);
      } else {
        store.commit('authorizationReject', error.response.data);
        navigateLoginUrl();
      }
    }
    return Promise.reject(error);
  },
);

// Exponential back-off retry delay between requests
// It retries if it is a network error or a 5xx error on an idempotent request (GET, HEAD, OPTIONS, PUT or DELETE)
axiosRetry(apiClient, { retryDelay: axiosRetry.exponentialDelay, retries: 5 });
